/* 
* File: \app\resourceCenter\XinhuaNews\directive\atlasCarouselWindow\atlasCarouselWindow.js
* Description: 
* Create Date: 2020-05-13
* Author: he.jianbo
* Author Email: hjb2722404@163.com
* -----
* Last Modified: 2020-05-13 上午10:36:42
* Modified By: he.jianbo
* modify description: 
* -----
* HISTORY:
* 日期                    	作者	说明
* -----------	---	----------------------------------------------------------
 */
angular.module('resourceCenterServiceModule')
    .controller('atlasCarouselWindowCtrl', ['$scope', 'options', '$modalInstance', 'xinhuaApiService', 'resCtrModalService', 'storageListenerService', '$state', 'mrApiService', 'modalDialog', '$window', function ($scope, options, $modalInstance, xinhuaApiService, resCtrModalService, storageListenerService, $state, mrApiService, modalDialog, $window) {

        initStatus();
        initData();

        /**
         * [initStatus 初始化状态]
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.windowTitle = '图片预览';
            $scope.status = {
                isShowOper: false,
            };
            $scope.data = {
                imgList: [],
                time: options.item.pubtime,
                curItem: {},
            };
        }

        /**
         * [initData 初始化图片数组]
         *
         * @return  {[type]}  [return description]
         */
        function initData() {
            let imgUrl = options.item[options.imgListKey];
            let imgList = [];
            if (typeof imgUrl === 'string') {
                imgList = imgUrl.split(';');
            } else if (angular.isArray(imgUrl)) {
                imgList = imgUrl;
            } else {
                imgList = [];
            }
            angular.forEach(imgList, function (item,index) {
                $scope.data.imgList.push({
                    bigImgurl: item[options.bigPicKey],
                    smallImgurl: item[options.smallPicKey],
                    info: options.item[options.infoKey],
                    index: index
                });
            });
            $scope.data.curItem = $scope.data.imgList[0];
        }

        /**
         * [close description] 取消
         * @return {[type]} [description]
         */
        $scope.close = function () {
            $modalInstance.dismiss({});
        };

        /**
         * [takeDraft 取稿操作]
         *
         * @return  {[type]}  [return description]
         */
        $scope.takeDraft = function () {
            var modalInstance = resCtrModalService.fullTakeDraft(options.takeDraftParams, false, [options.item]);
            modalInstance.result.then(
                function (data) {
                    storageListenerService.addListenerToResource('takeDraft');
                },
                function () {
                    storageListenerService.addListenerToResource('takeDraft');
                }

            );
        };

        /**
         * [addToPersonalMaterial 添加到个人素材]
         *
         * @return  {[type]}  [return description]
         */
        $scope.addToPersonalMaterial = function () {
            let item = $scope.data.curItem;
            let imgTitle = options.item.title;
            let imgname = item.bigImgurl;
            mrApiService
                .addToPersonel({
                    mrType: 'personal',
                    mainResourceType: '0',
                    fileName: imgTitle,
                    tempUrl: imgname,
                })
                .then(function (data) {
                    if (data.code === '200') {
                        modalDialog.alertType('添加成功', '', 'success', false);
                        $window.document.getSelection().collapse($window.document, 1);
                    } else {
                        modalDialog.alertType('', data.msg, 'error', false);
                    }
                    // console.log("加入WCM创作轴成功");
                });
        };

        /**
         * [goToDetail description] 图集模式细览跳转
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        $scope.goToDetail = function () {
            let routerName = options.goDetailPareams.routerName;
            delete options.goDetailPareams.routerName;
            var url = $state.href(routerName, options.goDetailPareams);
            window.open(url, '_blank');
        };

        /**
         * [picError 大图加载失败时隐藏操作按钮]
         *
         * @return  {[type]}  [return description]
         */
        $scope.picError = function () {
            $scope.curItem.imgError = true;
        };
    }]);
